import React from "react"
import { accesDirectItem } from "../acces-direct.module.scss"
import AccesDirectItem from "../AccesDirectItem/acces-direct-item"
import PropTypes from "prop-types"

const RenderAccesDirect = ({ accesDirectData }) => {
  const accesDirects = accesDirectData.allDirectLinkEntityDirectLinkEntity.edges
  return (
    <ul>
      {accesDirects.map(({ node }) => (
        <li key={node.drupal_id} className={accesDirectItem}>
          <AccesDirectItem accesDirect={node} />
        </li>
      ))}
    </ul>
  )
}

RenderAccesDirect.propTypes = {
  accesDirectData: PropTypes.object.isRequired,
}

export default RenderAccesDirect
